import Request from './request';

async function fetchOne(type) {// 获取单个
    return Request('get', "api/sub-account-setting", {type: type});
}

async function fetchAll() {
    return Request('get', "api/sub-account-settings");
}

export default {
    fetchOne,
    fetchAll
};